(function ($) {
  "use strict";
  jQuery(document).ready(function ($) {

    // ========== SLIDERS ==========
    if ($('.featured-image-slider').length && $('.featured-nav-slider').length) {
      $('.featured-image-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.featured-nav-slider'
      });

      $('.featured-nav-slider').slick({
        rows: 1,
        slidesToShow: 5,
        slidesToScroll: 1,
        focusOnSelect: true,
        adaptiveHeight: true,
        dots: false,
        arrows: false,
        centerMode: false,
        vertical: true
      });
    }

    if ($('.testimonial-slider').length) {
      $('.testimonial-slider').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        autoplay: false,
        autoplaySpeed: 5000,
        fade: true,
        prevArrow: "<button class='slick-prev slick-arrow slick-disabled' aria-label='Previous' type='button' aria-disabled='true'><svg xmlns='http://www.w3.org/2000/svg' width='72' height='59' viewBox='0 0 72 59' fill='none'> <path d='M3.41668 29.1886L68.4167 29.1886' stroke='#F6F4EB' stroke-width='5.5' stroke-linecap='round' stroke-linejoin='round'/> <path d='M29.6325 55.2944L3.41581 29.1904L29.6325 3.08203' stroke='#F6F4EB' stroke-width='5.5' stroke-linecap='round' stroke-linejoin='round'/> </svg><span class='d-none'>PREV</span></button>",
        nextArrow: "<button class='slick-next slick-arrow' aria-label='Next' type='button' aria-disabled='false'><svg xmlns='http://www.w3.org/2000/svg' width='72' height='59' viewBox='0 0 72 59' fill='none'> <path d='M68.5834 29.8114L3.58337 29.8114' stroke='#F6F4EB' stroke-width='5.5' stroke-linecap='round' stroke-linejoin='round'/> <path d='M42.3676 3.70564L68.5842 29.8096L42.3676 55.918' stroke='#F6F4EB' stroke-width='5.5' stroke-linecap='round' stroke-linejoin='round'/> </svg><span class='d-none'>NEXT</span></button>",
      });
    }

    if ($('.support-slider').length) {
      $('.support-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        autoplay: false,
        autoplaySpeed: 5000,
        rows: 2,
        responsive: [
          { breakpoint: 750, settings: { slidesToShow: 2 } },
          { breakpoint: 600, settings: { slidesToShow: 2 } },
          { breakpoint: 480, settings: { slidesToShow: 1 } }
        ]
      });
    }

    if ($('.pr-review-slider').length) {
      $('.pr-review-slider').slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        autoplay: false,
        autoplaySpeed: 5000,
        responsive: [
          { breakpoint: 991, settings: { slidesToShow: 3, arrows: false, centerMode: false } },
          { breakpoint: 800, settings: { slidesToShow: 3, arrows: false, centerMode: false } },
          { breakpoint: 750, settings: { slidesToShow: 2, centerMode: true, infinite: true } },
          { breakpoint: 600, settings: { slidesToShow: 2, centerMode: true, infinite: true } },
          { breakpoint: 480, settings: { slidesToShow: 1, centerMode: true, infinite: true } }
        ]
      });
    }

    if ($('.social-slider').length) {
      $('.social-slider').slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: false,
        autoplay: false,
        autoplaySpeed: 5000,
        responsive: [
          { breakpoint: 1050, settings: { slidesToShow: 4 } },
          { breakpoint: 991, settings: { slidesToShow: 4, infinite: true } },
          { breakpoint: 800, settings: { slidesToShow: 4, infinite: true } },
          { breakpoint: 750, settings: { slidesToShow: 4, infinite: true } },
          { breakpoint: 600, settings: { slidesToShow: 2, infinite: true } },
          { breakpoint: 480, settings: { slidesToShow: 1, infinite: true } }
        ]
      });
    }

    // ========== TILT EFFECT ==========
    if ($('.et-js-tilt').length) {
      $(".et-js-tilt").tilt({
        scale: 1.02,
        glare: true,
        maxGlare: 0.5,
        easing: "cubic-bezier(.03,.98,.52,.99)",
        speed: 400
      });
    }

    if ($('.et-js-tilt-alt').length) {
      $(".et-js-tilt-alt").tilt({
        scale: 1.01,
        glare: true,
        maxGlare: 0.2,
        easing: "cubic-bezier(.03,.98,.52,.99)",
        speed: 400,
        perspective: 1200,
        max: 15
      });
    }

    // ========== GENERAL FUNCTIONS ==========
    $('.search-toggle').click(function () {
      $('.header-search').toggleClass("active");
    });

    $('.close-search').click(function () {
      $('.header-search').removeClass("active");
    });

    $('.touchpoint').click(function (e) {
      e.stopPropagation();
      const parent = $(this).parent();
      if (parent.hasClass('active')) {
        parent.removeClass('active');
      } else {
        $('.touchpoint').parent().removeClass('active');
        parent.addClass('active');
      }
    });

    $(document).click(function () {
      $('.touchpoint').parent().removeClass('active');
    });

    $('.back-to-top').click(function (e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, 600);
    });

    $('#menu-toggle').click(function () {
      $('.mobile-menu-wrapper').toggleClass("open");
      $('body').addClass("act");
      $('.header-search').removeClass("active");
    });

    $('.menu-close').click(function () {
      $('.mobile-menu-wrapper').removeClass("open");
      $('body').removeClass("act");
      $('.header-search').removeClass("active");
    });

    let lastScrollTop = 0;
    $(window).on('scroll', function () {
      let currentScroll = $(this).scrollTop();
      if (currentScroll > 0) {
        $('.stick-header').addClass('scrolled');
        if (currentScroll < lastScrollTop) {
          $('.stick-header').addClass('scrolling-up');
        } else {
          $('.stick-header').removeClass('scrolling-up');
        }
      } else {
        $('.stick-header').removeClass('scrolled scrolling-up');
      }
      lastScrollTop = currentScroll;
    });

    $('.menu-list ul li').has('ul').each(function () {
      $(this).addClass('has-submenu');
      $(this).children('a').append('<span class="submenu-toggle-icon"></span>');
    });

    $('.menu-list ul li').has('ul').children('a').on('click', function (e) {
      e.preventDefault();
      const $submenu = $(this).siblings('ul');
      $(this).parent().siblings().find('ul').removeClass('active')
      $(this).parent().siblings().find('a').removeClass('active');
      $submenu.toggleClass('active');
      $(this).toggleClass('active');
    });

    $(document).click(function (e) {
      if (!$(e.target).closest('ul').length) {
        $('.menu-list ul li ul').removeClass('active')
        $('.menu-list ul li a').removeClass('active');
      }
    });

    $('.close-bar').click(function () {
      $('.top-bar').remove();
      $('body').removeClass("announcement-bar-active");
      localStorage.setItem('topBarClosed', 'true');
    });

    $('.mobile-filter-btn').click(function () {
      $('.collection-filters').slideToggle();
    });

  });
}(jQuery));


document.addEventListener('DOMContentLoaded', function () {
    const spans = document.querySelectorAll('.animated_heading span');
    if (spans.length === 0) return; // Exit if no spans found

    let current = 0;

    function showNextSpan() {
        spans.forEach(span => span.classList.remove('active'));
        spans[current].classList.add('active');
        current = (current + 1) % spans.length;
    }

    showNextSpan(); // Show the first span initially
    setInterval(showNextSpan, 1000); // Change every second
});

document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.megamenu-slider');

  sliders.forEach(slider => {
    const imgs = slider.querySelectorAll('img');
    let current = 0;

    function showNextimgs() {
      imgs.forEach(img => img.classList.remove('active'));
      imgs[current].classList.add('active');
      current = (current + 1) % imgs.length;
    }

    showNextimgs();
    setInterval(showNextimgs, 3000);
  });
});

//Video PLay Pause
document.addEventListener('DOMContentLoaded', function () {
    
  const wrappers = document.querySelectorAll('.testimonial-video-wrapper-v2');
  if(wrappers.length > 0) { 
  const popup = document.getElementById('video-popup');
  const popupVideo = document.getElementById('popupVideo');
  const popupSource = popupVideo.querySelector('source');
  const closeBtn = document.querySelector('.close-popup');

  let activeButton = null; 
 const videos = document.querySelectorAll('video[data-poster-mobile]');

  videos.forEach(video => {
    const mobilePoster = video.getAttribute('data-poster-mobile');
    const desktopPoster = video.getAttribute('data-poster-desktop');

    const isMobile = window.matchMedia('(max-width: 1023px)').matches;

    if (isMobile && mobilePoster) {
      video.setAttribute('poster', mobilePoster);
    } else if (desktopPoster) {
      video.setAttribute('poster', desktopPoster);
    }
  });
  wrappers.forEach(wrapper => {
    const button = wrapper.querySelector('.play-pause-btn');
    const icon = button.querySelector('i');
    const localVideo = wrapper.querySelector('video');
    const videoSrc = localVideo.querySelector('source')?.src || localVideo.getAttribute('src');
    const poster = localVideo.getAttribute('poster');

    button.addEventListener('click', function () {
      activeButton = button; // ← Guardar botón activo

      popupSource.src = videoSrc;
      popupVideo.poster = poster;
      popupVideo.load();

      popup.style.display = 'flex';
      popupVideo.style.objectFit = 'contain';
      popupVideo.play();

      icon.classList.remove('fa-play');
      icon.classList.add('fa-pause');
      button.style.width = '60px';
      button.style.height = '60px';
      icon.style.fontSize = '2rem';
    });
  });

  popupVideo.addEventListener('ended', () => {
    popupVideo.style.objectFit = 'cover';
    closePopup();
  });

  closeBtn.addEventListener('click', closePopup);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.style.display === 'flex') {
      closePopup();
    }
  });

  function closePopup() {
    popup.style.display = 'none';
    popupVideo.pause();
    popupVideo.currentTime = 0;
    popupSource.src = '';
    popupVideo.load();

    if (activeButton) {
      const icon = activeButton.querySelector('i');
      icon.classList.remove('fa-pause');
      icon.classList.add('fa-play');

      activeButton.style.width = '80px';
      activeButton.style.height = '80px';
      icon.style.fontSize = '3rem';

      activeButton = null; 
    }
  }
    }
});
/*
document.addEventListener('DOMContentLoaded', function () {
  const wrappers = document.querySelectorAll('.testimonial-video-wrapper');

  wrappers.forEach(wrapper => {
    const video = wrapper.querySelector('video');
    const button = wrapper.querySelector('.play-pause-btn');
    const icon = button.querySelector('i');
    
    // Find the testimonial box within the same testimonial slide
    const testimonialBox = wrapper.closest('.ts-slide').querySelector('.testimonial-box');

    // Ensure the video starts paused
    video.pause();

    button.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        icon.classList.remove('fa-play');
        icon.classList.add('fa-pause');
        video.style.objectFit = 'contain';
        button.style.height = '60px';
        button.style.width = '60px';
        icon.style.fontSize = '2rem';
        if (testimonialBox) {
          testimonialBox.style.display = 'none';
        }
      } else {
        video.pause();
        icon.classList.remove('fa-pause');
        icon.classList.add('fa-play');
        video.style.objectFit = 'cover';
         button.style.height = '80px';
        button.style.width = '80px';
        icon.style.fontSize = '3rem';
        if (testimonialBox) {
          testimonialBox.style.display = 'block';
        }

        // Reset the video
        video.currentTime = 0;
        video.load();
      }
    });

    // Hide testimonial text when video starts playing
    video.addEventListener('play', () => {
      video.style.objectFit = 'contain';
      if (testimonialBox) {
        testimonialBox.style.display = 'none';
      }
    });

    // Show testimonial text again when video ends
    video.addEventListener('ended', () => {
      video.style.objectFit = 'cover';
      if (testimonialBox) {
        testimonialBox.style.display = 'block';
      }
      icon.classList.remove('fa-pause');
      icon.classList.add('fa-play');

         // Reset button size
      button.style.width = '80px';
      button.style.height = '80px';
      icon.style.fontSize = '3rem';
    });
  });
});
*/


gsap.registerPlugin(ScrollTrigger);

const animateIfExists = (selector, animation) => {
    if (document.querySelector(selector)) {
        gsap.to(selector, animation);
    }
};

animateIfExists(".hero_shape_1", {
    y: 110,
    scrollTrigger: {
        trigger: ".hero-area",
        start: "top 100%",
        end: "bottom 50%",
        scrub: true,
    },
});

animateIfExists(".hero_shape_2", {
    x: -110,
    scrollTrigger: {
        trigger: ".hero-area",
        start: "top 50%",
        end: "bottom 50%",
        scrub: true,
    },
});

animateIfExists(".page_banner_shape_1", {
    x: -110,
    scrollTrigger: {
        trigger: ".page-banner-area",
        start: "top 50%",
        end: "bottom 50%",
        scrub: true,
    },
});

animateIfExists(".support-shape-2", {
    x: 110,
    scrollTrigger: {
        trigger: ".support-area",
        start: "top 100%",
        end: "bottom 50%",
        scrub: true,
    },
});

animateIfExists(".support-shape-1", {
    x: -60,
    scrollTrigger: {
        trigger: ".support-area",
        start: "top 100%",
        end: "bottom 50%",
        scrub: true,
    },
});

animateIfExists(".care_shape_1", {
    x: 180,
    scrollTrigger: {
        trigger: ".care-area",
        start: "top 150%",
        end: "bottom 50%",
        scrub: true,
    },
});

animateIfExists(".care_shape_2", {
    x: -180,
    scrollTrigger: {
        trigger: ".care-area",
        start: "top 100%",
        end: "bottom -100%",
        scrub: true,
    },
});

animateIfExists(".testimonial-bg", {
    scale: 1.2,
    scrollTrigger: {
        trigger: ".testimonial-area",
        start: "top 150%",
        end: "bottom 50%",
        scrub: true,
    },
});

animateIfExists(".pr-shape-1", {
    x: -120,
    scrollTrigger: {
        trigger: ".product-review-area",
        start: "top 150%",
        end: "bottom 50%",
        scrub: true,
    },
});

animateIfExists(".pr-shape-2", {
    x: 120,
    scrollTrigger: {
        trigger: ".product-review-area",
        start: "top 50%",
        end: "bottom 50%",
        scrub: true,
    },
});

animateIfExists(".pr-shape-3", {
    x: -100,
    scrollTrigger: {
        trigger: ".product-review-area",
        start: "top 100%",
        end: "bottom -200%",
        scrub: true,
    },
});

animateIfExists(".cta-shape-1", {
    x: 130,
    scrollTrigger: {
        trigger: ".cta-area-v2",
        start: "top 50%",
        end: "bottom 100%",
        scrub: true,
    },
});

animateIfExists(".follow-shape-1", {
    x: -130,
    scrollTrigger: {
        trigger: ".tips-area",
        start: "top 100%",
        end: "bottom 100%",
        scrub: true,
    },
});

animateIfExists(".tip-shape-2", {
    x: 70,
    scrollTrigger: {
        trigger: ".tips-area .container",
        start: "top 100%",
        end: "bottom 100%",
        scrub: true,
    },
});
